export const thresholds = {
    mobile: 1220
}